import React, { Component } from 'react';
import API from "../../config/api";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import moment from 'moment';
import { Link, Navigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { exportToExcel } from "../Helper/exportToExcel";

export class UserReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nb_days: 15,
      data: [],
      nav_id: null,
      date: new Date(),
      startDate: null,
      endDate: null, 
      top_users: null,
      new_users: null,
      active_users: null,
      total_users: [],
      active_users_30days: [],
    }
  }

  componentDidMount(){

   this.getUsersReport()
    
  }


  getRamdom() {
    // return Math.floor(Math.random() * 1000) + 3000
  }

  getDay(i) {
    return moment().subtract(i, 'day').format("DD")
  }

  searchByDate = (range) => {
    const [startDate, endDate] = range;
    this.state.startDate = startDate;
    this.state.endDate = endDate;
    this.setState({})
    // this.setState({startDate})
    // this.setState({endDate})

    this.getUsersReport();
  };

  getUsersReport = async () => {
    try {
      // let query = `page=${this.state.page}`
      // moment().format("MMM Do YY");
      let query ='';
      let start_date = '';
      let end_date = '';
      
      if(this.state.startDate) {
        start_date = moment(this.state.startDate).format("YYYY-MM-DD");
        end_date = moment(this.state.endDate).format("YYYY-MM-DD");
      }
      

      console.log(start_date, end_date, this.state.nb_days)
      // let query = `nb_days=14`
      
      if(this.state.nb_days) {
        console.log(this.state.nb_days)
        query = `nb_days=${this.state.nb_days}`
      }

      if(start_date) {
        console.log(start_date)
        query = `start_date=${start_date}&&end_date=${end_date}`
      }

      // this.query = `start_date=${start_date}&&end_date=${end_date}`

      let result = await API.getUsersReport(query);
      let data = result.data

      let tempArray = []

      // for (let i = this.state.nb_days; i > 0; i--) {
      for (let i = data.active_users_30days.length -1 ; i > -1; i--) {  
        tempArray.push({
          key: i,
          // active_users: this.getRamdom(),
          active_users: data.active_users_30days[i],
          name: this.getDay(i+1)
        })
      }
      console.log(data)

      this.setState({data: tempArray, active_users : data.active_users.toLocaleString('en-US'), total_users: data.total_users.toLocaleString('en-US'), new_users: data.new_users.toLocaleString('en-US'), 
        top_users: data.top_users, active_users_30days: data.active_users_30days });

    } catch (error) {
      console.log(error)
    }
  }

  exportUsersToExcel = (data, filename) => {
    exportToExcel(data, filename);
  }

  render() {
    return (
      <div class="col-lg-12">
        {/* {this.state.nav_id && (
            <Navigate to={`/userview?id=${this.state.nav_id}`} replace={true} />
          )} */}

                <div className="flexbox mb-20">
                    <div className="lookup">
                      {/* <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} /> */}
                      <DatePicker
                        className="w-300px"
                        showIcon
                        icon="fa fa-calendar"
                        selected={this.state.startDate}
                        onChange={this.searchByDate}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        // minDate={this.state.startDate}
                        placeholderText="Select specific day"
                        dateFormat="MMMM d, yyyy"
                        isClearable
                        selectsRange
                      />
                    </div>

                    <div className="btn-toolbar">
                      <div className="btn-group btn-group-sm">
                      <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button>
                        <div className="dropdown-menu dropdown-menu-right">
                            <Link class="dropdown-item"  ><i class="fa fa-file-zip-o"></i> Zip</Link>
                            <Link class="dropdown-item"  ><i class="fa fa-file-pdf-o"></i> PDF</Link>
                            <Link class="dropdown-item" onClick={(event) => {this.exportUsersToExcel(this.state.top_users, "top user report")}}  ><i class="fa fa-file-excel-o"></i> Excel</Link>
                        </div>
                        <select data-provide="selectpicker" data-width="100">
                          <option>Today</option>
                          <option>Yesterday</option>
                          <option>Last week</option>
                          <option>Last month</option>
                          <option>All time</option>
                        </select>
                      </div>
                    </div>
                  </div>
                <div></div>






        <div className=''>
          <div className='row'>
          <div class="col-md-6 col-lg-4">
            <div class="card card-body">
              <div class="flexbox">
                <div data-provide="sparkline" data-width="100" data-fill-color="false" data-line-width="2">1,4,3,7,6,4,8,9,6,8,12</div>
                <div class="text-right">
                  <span class="fw-400">New Users</span><br />
                  <span>
                    <i class="ti-angle-up text-success"></i>
                    <span class="fs-18 ml-1">{this.state.new_users}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="card card-body">
              <div class="flexbox">
                <div data-provide="sparkline" data-type="bar" data-bar-color="#f2a654">1,4,3,7,6,4,8,9,6,8,12</div>
                <div class="text-right">
                  <span class="fw-400">Active Users</span><br />
                  <span>
                    <i class="ti-angle-up text-success"></i>
                    <span class="fs-18 ml-1">{this.state.active_users}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="card card-body">
              <div class="flexbox">
                <div data-provide="sparkline" data-type="discrete" data-width="50" data-line-color="#926dde">1,4,3,7,6,4,8,9,6,8,12</div>
                <div class="text-right">
                  <span class="fw-400">Total Users</span><br />
                  <span>
                    <i class="ti-angle-up text-success"></i>
                    <span class="fs-18 ml-1">{this.state.total_users}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>

        {/* <div className='row'>
          <div class="col-md-6 col-lg-4">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title">Top Country</h5>
                <ul class="card-controls">
                  <li class="dropdown">
                    <a data-toggle="dropdown" href="#"><i class="ti-more-alt rotate-90"></i></a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item active" href="#">Today</a>
                      <a class="dropdown-item" href="#">Yesterday</a>
                      <a class="dropdown-item" href="#">Last week</a>
                      <a class="dropdown-item" href="#">Last month</a>
                    </div>
                  </li>
                  <li><a class="card-btn-reload" href="../assets/data/general.html" title="Refresh" data-provide="tooltip"><i class="fa fa-circle-thin"></i></a></li>
                </ul>
              </div>

              <div class="card-body card-body">
                <div class="text-center py-20">
                  <div data-provide="peity" data-type="donut" data-size="150" data-inner-radius="55" data-fill="#efb3e6,#ffdf7c,#b2def7">9,6,5</div>
                </div>

                <ul class="list-inline">
                  <li class="flexbox mb-1">
                    <div>
                      <span class="badge badge-dot badge-lg mr-1" style={{backgroundColor : '#efb3e6'}}></span>
                      <span>Cambodia</span>
                    </div>
                    <div>953</div>
                  </li>

                  <li class="flexbox mb-1">
                    <div>
                      <span class="badge badge-dot badge-lg mr-1" style={{backgroundColor : '#ffdf7c'}} ></span>
                      <span>Lao</span>
                    </div>
                    <div>813</div>
                  </li>

                  <li class="flexbox">
                    <div>
                      <span class="badge badge-dot badge-lg mr-1" style={{backgroundColor : '#b2def7'}} ></span>
                      <span>Thailand</span>
                    </div>
                    <div>369</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title">Gender</h5>

                <ul class="card-controls">
                  <li class="dropdown">
                    <a data-toggle="dropdown" href="#"><i class="ti-more-alt rotate-90"></i></a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item active" href="#">Today</a>
                      <a class="dropdown-item" href="#">Yesterday</a>
                      <a class="dropdown-item" href="#">Last week</a>
                      <a class="dropdown-item" href="#">Last month</a>
                      <a class="dropdown-item" href="#">All time</a>
                    </div>
                  </li>
                  <li><a class="card-btn-reload" href="../assets/data/general.html" title="Refresh" data-provide="tooltip"><i class="fa fa-circle-thin"></i></a></li>
                </ul>
              </div>

              <div class="card-body card-body">
                <div class="text-center py-20">
                  <div data-provide="peity" data-type="pie" data-size="150" data-inner-radius="55" data-fill="#33cabb,#48b0f7,#fdd501">9,6,5</div>
                </div>

                <ul class="flexbox flex-justified text-center mt-30">
                  <li class="br-1 botder-light">
                    <div class="fs-20 text-primary">953</div>
                    <small>Male</small>
                  </li>

                  <li class="br-1 botder-light">
                    <div class="fs-20 text-info">813</div>
                    <small>Female</small>
                  </li>

                  <li>
                    <div class="fs-20 text-yellow">369</div>
                    <small>Other</small>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title">Top City</h5>

                <ul class="card-controls">
                  <li class="dropdown">
                    <a data-toggle="dropdown" href="#"><i class="ti-more-alt rotate-90"></i></a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item active" href="#">Today</a>
                      <a class="dropdown-item" href="#">Yesterday</a>
                      <a class="dropdown-item" href="#">Last week</a>
                      <a class="dropdown-item" href="#">Last month</a>
                    </div>
                  </li>
                  <li><a class="card-btn-reload" href="../assets/data/general.html" title="Refresh" data-provide="tooltip"><i class="fa fa-circle-thin"></i></a></li>
                </ul>
              </div>

              <div class="card-body card-body">
                <p>Synergistically repurpose market positioning functionalities via top-line.repurpose market positioningrepurpose market positioning</p>
                <div class="flexbox mt-70">
                  <div data-provide="peity" data-type="bar" data-height="130" data-width="90" data-fill="#33cabb,#48b0f7,#fdd501">953,813,369</div>

                  <ul class="list-inline align-self-end text-muted text-right mb-0">
                    <li>Phnom Penh <span class="badge badge-ring badge-primary ml-2"></span></li>
                    <li>Battambang <span class="badge badge-ring badge-info ml-2"></span></li>
                    <li>Kandal <span class="badge badge-ring badge-yellow ml-2"></span></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className='card'>
          <div class="card-header">
            <h5 class="card-title">Active users Previous Days</h5>

            {/* <ul class="card-controls">
              <li class="dropdown">
                <a data-toggle="dropdown" href="#"><i class="ti-more-alt rotate-90"></i></a>
                <div class="dropdown-menu dropdown-menu-right">
                  <a class="dropdown-item active" href="#">Today</a>
                  <a class="dropdown-item" href="#">Yesterday</a>
                  <a class="dropdown-item" href="#">Last week</a>
                  <a class="dropdown-item" href="#">Last month</a>
                </div>
              </li>
              <li><a class="card-btn-reload" href="../assets/data/general.html" title="Refresh" data-provide="tooltip"><i class="fa fa-circle-thin"></i></a></li>
            </ul> */}
          </div>

          <div class="card-body card-body">
        {
          this.state.data.length != 0 && 
          <div  style={{width: '100%', height: 300 }}>
          <ResponsiveContainer debounce={300} width="100%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={this.state.data}
              // data={this.state.active_users_30days}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
              barSize={20}
            >
              <XAxis dataKey="name" scale="point" padding={{ left: 10, right: 10 }} />
              <YAxis />
              <Tooltip />
              <Legend />
              <CartesianGrid strokeDasharray="3 3" />
              <Bar dataKey="active_users" fill="#4ed2c5" background={{ fill: '#eee' }} />
            </BarChart>
          </ResponsiveContainer>
          </div>
        }
          </div>
        </div>
        
        <div class="card">
          <div class="card-header">
            <h5 class="card-title"><strong>User Report</strong></h5>
            <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
          {/* <Link class="btn btn-xs btn-light" to=''>See all</Link> */}
            

            {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button>
            <div className="dropdown-menu dropdown-menu-right">
                <Link class="dropdown-item"  ><i class="fa fa-file-zip-o"></i> Zip</Link>
                <Link class="dropdown-item"  ><i class="fa fa-file-pdf-o"></i> PDF</Link>
                <Link class="dropdown-item"  ><i class="fa fa-file-excel-o"></i> Excel</Link>
            </div>
            <select data-provide="selectpicker" data-width="100">
              <option>Today</option>
              <option>Yesterday</option>
              <option>Last week</option>
              <option>Last month</option>
              <option>All time</option>
            </select> */}
                
            </div>
          </div>

            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th><h6>#</h6></th>
                  <th className="text-center w-40px"><h6>Profile</h6></th>
                  <th ><h6>User Name</h6></th>
                  <th ><h6>Phone Number</h6></th>
                  <th ><h6>Gender</h6></th>
                  <th ><h6>Email</h6></th>
                  <th ><h6>Spent</h6></th>
                  <th ><h6>Join Date</h6></th>
                  <th class="w-80px text-center">Action</th>
                </tr>
              </thead>
              <tbody>
              { this.state.top_users &&
                  this.state.top_users.map((user, index) => {
                    return <tr>
                      <td>{index + 1}</td>
                      <td className="text-center w-40px">
                          <div class="media">
                            <img class="avatar" src={user.profile_url ? user.profile_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                            <div class="media-body">
                              {/* <p >{video.title_kh}</p> */}
                            </div>
                          </div>
                        </td>
                      <td ><strong>{user.nick_name}</strong></td>
                      <td >{user.phone_number}</td>
                      <td >{user.gender_id === 1? "Male" : "Female"}</td>
                      <td >{user.email}</td>
                      <td className="text-success fw-500 w-80px"><b>${user.total_spent.toLocaleString('en-US')}</b></td>
                      <td >{moment(user.created_at).format("DD-MMM-YYYY")}</td>
                      <td>
                        <nav class="nav no-gutters gap-2 fs-16">
                          <Link class="nav-link hover-primary" to={`/userview?id=${user.id}`} data-provide="tooltip" title="View"><i class="ti-eye"></i></Link>
                        </nav>
                      </td>
                    </tr>
                  })
              }



                {/* <tr onClick={(event) =>{
                  this.state.nav_id = 1
                  this.setState({})
                }}>
                  <td>1</td>
                  <td><a class="hover-primary" href="#">Ranian</a></td>
                  <td>$9</td>
                  <td>21 July 2024</td>
                  <td>
                  <nav class="nav no-gutters gap-2 fs-16">
                    <Link class="nav-link hover-primary" to={`/userview?id=1`} data-provide="tooltip" title="Edit"><i class="ti-eye"></i></Link>
                  </nav>
                </td>
                </tr>
                <tr onClick={(event) =>{
                  this.state.nav_id = 2
                  this.setState({})
                }}>
                  <td>2</td>
                  <td><a class="hover-primary" href="#">Makein</a></td>
                  <td>$9</td>
                  <td>21 July 2024</td>
                  <td>
                  <nav class="nav no-gutters gap-2 fs-16">
                    <Link class="nav-link hover-primary" to={`/userview?id=2`} data-provide="tooltip" title="View"><i class="ti-eye"></i></Link>
                  </nav>
                </td>
                </tr>
                <tr onClick={(event) =>{
                  this.state.nav_id = 3
                  this.setState({})
                }}>
                  <td>3</td>
                  <td><a class="hover-primary" href="#">Suhan</a></td>
                  <td>$19</td>
                  <td>21 July 2024</td>
                  <td>
                  <nav class="nav no-gutters gap-2 fs-16">
                    <Link class="nav-link hover-primary" to={`/userview?id=3`} data-provide="tooltip" title="View"><i class="ti-eye"></i></Link>
                  </nav>
                </td>
                </tr>
                <tr onClick={(event) =>{
                  this.state.nav_id = 4
                  this.setState({})
                }}>
                  <td>4</td>
                  <td><a class="hover-primary" href="#">Inamu</a></td>
                  <td>$9</td>
                  <td>12 June 2000</td>
                  <td>
                  <nav class="nav no-gutters gap-2 fs-16">
                    <Link class="nav-link hover-primary" to={`/userview?id=4`} data-provide="tooltip" title="View"><i class="ti-eye"></i></Link>
                  </nav>
                </td>
                </tr>
                <tr onClick={(event) =>{
                  this.state.nav_id = 5
                  this.setState({})
                }}>
                  <td>5</td>
                  <td><a class="hover-primary" href="#">Finak</a></td>
                  <td>$49</td>
                  <td>21 July 2024</td>
                  <td>
                  <nav class="nav no-gutters gap-2 fs-16">
                    <Link class="nav-link hover-primary" to={`/userview?id=5`} data-provide="tooltip" title="View"><i class="ti-eye"></i></Link>
                  </nav>
                </td>
                </tr>
                <tr onClick={(event) =>{
                  this.state.nav_id = 6
                  this.setState({})
                }}>
                  <td>6</td>
                  <td><a class="hover-primary" href="#">Kurady</a></td>
                  <td>$19</td>
                  <td>21 July 2024</td>
                  <td>
                  <nav class="nav no-gutters gap-2 fs-16">
                    <Link class="nav-link hover-primary" to={`/userview?id=6`} data-provide="tooltip" title="View"><i class="ti-eye"></i></Link>
                  </nav>
                </td>
                </tr> */}
              </tbody>
            </table>

          </div>
        </div>  
    )
  }
}

export default UserReport